import { z } from "zod";
const schemaBitcoinGetAddressParams = z.object({
    accountId: z.string(),
    derivationPath: z.string().optional(),
});
const schemaBitcoinGetAddressResults = z.object({
    address: z.string(),
});
export const schemaBitcoinGetAddress = {
    params: schemaBitcoinGetAddressParams,
    result: schemaBitcoinGetAddressResults,
};
//# sourceMappingURL=BitcoinGetAddress.js.map